<template>
  <div class="page">
    <v-row>
      <v-col cols="12" md=6 class="text-center">
        <h1 class="quizz-title text-center">Trouver mon style</h1>
        <p class="pa-1" style="">
          Dites-nous si vous aimez ou non <br/>le style représenté dans les photos suivantes.
        </p>
        <div class="page-deco" :class="{
          'page-deco-sm': $vuetify.breakpoint.smOnly,
          'page-deco-xs': $vuetify.breakpoint.xsOnly
        }"></div>
      </v-col>

      <v-col cols="12" md=6>
        <v-container v-if="quizzDone" class="quizz-card">
          <div
          v-if="!contactSent"
          class="d-flex flex-column justify-space-between" style="height:100%">
            <v-row>
              <div class="text-center">
                <h2>Obtenez votre style de jardin</h2>
                <p>
                  Il ne vous reste plus qu’à vous inscrire pour le recevoir gratuitement.
                </p>
              </div>
              <v-col cols="12">
                <v-text-field label="Nom*" v-model="contact.name" required outlined></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="Courriel*" type="email" v-model="contact.email" outlined required></v-text-field>
              </v-col>
            </v-row>
            <v-btn rounded depressed color="#ef6758" style="color:white" @click="send" :loading="wip" :disabled="wip">
              Envoyer
            </v-btn>
            <br/>
            <v-alert
              v-if="hasError"
              class="my-3"
              outlined
              type="error"
            >
              Impossible d'envoyer votre message. Réessayez ultérieurement.
            </v-alert>
          </div>
          <div v-else>
            <v-alert
              outlined
              type="success"
            >
              Nous vous remercions d'avoir participé.e au quizz. Vous allez recevoir le résultat dans quelques instants dans votre boîte mail. A bientôt chez HortusBox.
            </v-alert>
          </div>
        </v-container>

        <p class="quizz-container">

          <v-card
            v-if="current && !quizzDone"
            class="quizz-card"
          >
            <v-progress-linear color="#ef6758" :value="progress"></v-progress-linear>
            <div>
              <v-img
                @load="onImgLoad()"
                class="white--text align-end quizz-img"
                :src="current.Picture.url"
              >
              </v-img>
            </div>

            <v-card-actions class="d-flex justify-space-around my-5">
              <v-btn fab dark large color="error" @click="ignoreIt()">
                <v-icon dark>
                  mdi-thumb-down
                </v-icon>
              </v-btn>

              <v-btn fab dark large color="success" @click="likeIt()">
                <v-icon dark>
                  mdi-thumb-up
                </v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </p>
      </v-col>
    </v-row>

    <v-overlay :value="showOverlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

  </div>
</template>

<script>
import K from '../K'
import axios from 'axios'
import { mapActions } from 'vuex'
export default {
  data: () => ({
    progress: 0,
    wip: false,
    quizzDone: false,
    hasError: null,
    contactSent: false,
    showOverlay: false,
    cursor: 0,
    current: null,
    questions: [],
    result: {},
    contact: {
      host: window.location.hostname,
      uid: localStorage.getItem(K.userId),
      name: '',
      email: '',
      comment: '',
      result: ''
    }
  }),
  methods: {
    ...mapActions('strapiv2', ['getQuizz']),
    ignoreIt () {
      this.getNext()
    },
    likeIt () {
      this.result[this.current.Style.Iso] = this.result[this.current.Style.Iso] || 0
      this.result[this.current.Style.Iso]++
      this.getNext()
    },
    onImgLoad () {
      this.showOverlay = false
    },
    getNext () {
      if (this.cursor === this.questions.length) {
        this.progress = 100
        this.quizzDone = true
      } else {
        if (this.questions.length > 0) {
          this.progress = 100 * this.cursor / this.questions.length
          console.log(this.progress)
        }
        this.showOverlay = true
        this.current = this.questions[this.cursor]
        this.cursor++
      }
    },
    send () {
      this.contact.result = this.result
      this.hasError = false
      if (!this.contact.name) {
        return
      }
      if (!this.contact.email) {
        return
      }
      this.wip = true
      axios.post('/sky/web/quizz', this.contact)
        .then(() => {
          this.contactSent = true
        })
        .catch(() => {
          this.hasError = true
        })
        .finally(() => {
          this.wip = false
        })
    }
  },
  async mounted () {
    try {
      this.questions = await this.getQuizz()
      this.getNext()
    } catch (e) {
      console.error(e)
    }
  }
}
</script>

<style scoped>
.page {
  /* margin: 0; */
}

.page-deco {
  background-image: url('https://storage.service.hortusbox.com/strapi/trouver_mon_style_a2715efcab.jpg');
  background-size: contain;
  background-position: bottom center;
  height: 50vh;
  width: 100%;
  margin: 0 0 -12px 0;
}

.page-deco-sm {
  height: 15vh;
}

.page-deco-xs {
  height: 10vh;
}

.quizz-progress {
  /* margin-bottom: 3em; */
}

.quizz-container {
  /* height: 60vh; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.quizz-title {
  margin-bottom: 1em;
}

.quizz-card {
  width: 400px;
}

.quizz-img {
  height: 400px;
}

@media (max-width: 450px) {
  .page {
    margin-top: 0.8em;
  }

  .page-deco {
    height: 10vh;
  }

  .quizz-progress {
    /* margin-bottom: 0.5em; */
  }

  .quizz-container {
    /* height: 70vh; */
    display: block;
    padding: 0 15px;
  }

  .quizz-title {
    margin-bottom: 0em;
  }

  .quizz-card {
    width: auto;
    max-width: 400px;
  }

  .quizz-img {
    height: 300px;
  }

}
</style>